import { router } from "@/utils";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FC } from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { UIContextProvider } from "@/stores";
import { Modal } from "@/components";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retryDelay: 10000,
      onError: () => {},
    },
  },
});

const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={darkTheme}>
        <UIContextProvider>
          <CssBaseline />
          <Toaster />
          <RouterProvider router={router} />
          <Modal />
        </UIContextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export { App };
